import _define_property from "@swc/helpers/src/_define_property.mjs";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Text, designTokens } from "@cinch-labs/design-system";
import cx from "classnames";
import { useState } from "react";
import AdminFeeButton from "../admin-fee-button/admin-fee-button";
import { AdminFeeDrawer } from "../admin-fee-drawer/admin-fee-drawer";
import { TrackingEventTypes, useAnalytics } from "@cinch-nx/shared-analytics";
import { Card } from "../card/card";
import Price from "../price/price";
import { ProductImage } from "../product-image/product-image";
import { SaveButton } from "../save-button/save-button";
import { Subtitle } from "../subtitle/subtitle";
import { Tags } from "../tags/tags";
import { Title } from "../title/title";
import styles from "./product-list-card.module.css";
import { Env, readFromEnv } from "@cinch-nx/environments";
var filterTestTags = function(tag) {
    if (tag.label) {
        return tag.label.match(/Mileage|Fuel Type|Transmission Type/);
    }
    return null;
};
var hyphenate = function(text) {
    return text ? text.replace(/\s+/g, "-").toLowerCase() : "";
};
var font = designTokens.customProperties.ds.font;
var ERROR_MESSAGE = "Image Unavailable";
export var ProductListCard = function(param) {
    var id = param.id, price = param.price, image = param.image, title = param.title, subtitle = param.subtitle, isSaved = param.isSaved, _isPending = param.isPending, isPending = _isPending === void 0 ? false : _isPending, isAvailable = param.isAvailable, onSave = param.onSave, tags = param.tags, unavailable = param.unavailable, isReserved = param.isReserved, make = param.make, model = param.model, vehicleYear = param.vehicleYear, discountInPence = param.discountInPence, _showActions = param.showActions, showActions = _showActions === void 0 ? true : _showActions, _isSmallCardSize = param.isSmallCardSize, isSmallCardSize = _isSmallCardSize === void 0 ? false : _isSmallCardSize, isPersonalised = param.isPersonalised, onCardClick = param.onCardClick;
    var hasAdminFeeComplianceBeenSet = readFromEnv(Env.AdminFeeCompliance) === "true";
    var tagsCarCards = tags.filter(function(tag) {
        return filterTestTags(tag);
    });
    var vehicleTitle = "".concat(vehicleYear, " ").concat(title);
    var showOfferTag = !!discountInPence;
    var ref = useState(false), shouldShowAdminFeeDrawer = ref[0], setShouldShowAdminFeeDrawer = ref[1];
    var trackEvent = useAnalytics().trackEvent;
    var handleAdminFeeClick = function() {
        setShouldShowAdminFeeDrawer(!shouldShowAdminFeeDrawer);
        if (shouldShowAdminFeeDrawer === false) {
            trackEvent({
                eventName: "product list card - admin fees",
                type: TrackingEventTypes.ADOBE,
                data: {
                    event: {
                        name: "click",
                        category: "admin fees",
                        label: "info",
                        action: "view",
                        value: isPersonalised ? "personalised" : "non-personalised"
                    }
                }
            });
        }
    };
    var _obj;
    return /*#__PURE__*/ _jsxs(Card, {
        "data-testid": "product-list-card",
        element: "article",
        isHoverable: true,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: cx(styles.meta, styles.metaCarCards, (_obj = {}, _define_property(_obj, styles.unavailable, !isAvailable), _define_property(_obj, styles.metaCarCardsPreAdminFeeCompliance, !hasAdminFeeComplianceBeenSet), _obj)),
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx(Title, {
                                element: "h2",
                                className: cx(styles.title, styles.titleCarCards),
                                fontSizeFixed: "m",
                                type: "cardTitle",
                                isPending: isPending,
                                "aria-describedby": isReserved ? "vehicle-reserved-".concat(id) : undefined,
                                children: /*#__PURE__*/ _jsx("a", {
                                    "data-testid": "product-list-card-link",
                                    href: "/used-cars/".concat(hyphenate(make), "/").concat(hyphenate(model), "/details/").concat(id),
                                    className: styles.link,
                                    onClick: function() {
                                        return onCardClick ? onCardClick() : null;
                                    },
                                    children: vehicleTitle
                                })
                            }),
                            /*#__PURE__*/ _jsx(Subtitle, {
                                isPending: isPending,
                                fontSize: "s",
                                children: subtitle
                            }),
                            /*#__PURE__*/ _jsx(Tags, {
                                isPending: isPending,
                                listStyleClassName: styles.tagsCarCards,
                                listItemClassName: styles.tagItemCarCard,
                                items: tagsCarCards
                            })
                        ]
                    }),
                    isAvailable && /*#__PURE__*/ _jsx(Price, {
                        isPending: isPending,
                        price: price,
                        vehicleId: id,
                        shouldShowCarsOnOfferTag: showOfferTag,
                        discountInPence: discountInPence,
                        showSmallFontSize: isSmallCardSize
                    }),
                    !hasAdminFeeComplianceBeenSet && /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(AdminFeeButton, {
                                onAdminFeeClick: function() {
                                    return handleAdminFeeClick();
                                }
                            }),
                            /*#__PURE__*/ _jsx(AdminFeeDrawer, {
                                showAdminFeeDrawer: shouldShowAdminFeeDrawer,
                                onClose: function() {
                                    return handleAdminFeeClick();
                                }
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.imageContainer,
                children: [
                    /*#__PURE__*/ _jsx(ProductImage, {
                        alt: title,
                        isAvailable: isAvailable,
                        image: image,
                        unavailableImageMessage: !isAvailable && " " || unavailable || ERROR_MESSAGE,
                        isPending: isPending
                    }),
                    showActions && /*#__PURE__*/ _jsx("div", {
                        className: styles.actions,
                        children: !!onSave && isAvailable && /*#__PURE__*/ _jsx(SaveButton, {
                            isPending: isPending || !isAvailable && !isSaved,
                            className: styles.save,
                            isSaved: isSaved,
                            onClick: function() {
                                return onSave(!isSaved);
                            },
                            size: font.size.xxl
                        })
                    }),
                    isReserved && /*#__PURE__*/ _jsx(Text, {
                        fontWeight: "book",
                        className: styles.reserved,
                        "data-testid": "vehicle-is-reserved",
                        id: "vehicle-reserved-".concat(id),
                        children: "Currently reserved"
                    })
                ]
            })
        ]
    });
};
